/**
 * Auto-apply a product tag facet based on the logged-in customer's type.
 *
 * This script is loaded via the `auto-customer-filter` script tag inserted by
 * the `snippets/auto-customer-filter.liquid` snippet. It reads configuration
 * from data attributes to keep logic theme-agnostic and minimize edits.
 */

(() => {
  const scriptEl =
    document.currentScript || document.getElementById("auto-customer-filter");
  if (!scriptEl) return;

  const customerType = scriptEl.getAttribute("data-customer-type");
  const companyValue = scriptEl.getAttribute("data-company-filter-value") || "";
  const associationValue =
    scriptEl.getAttribute("data-association-filter-value") || "";

  if (!customerType) return; // Not logged in or no relevant tag

  // Only run on collection templates (results-list present on Horizon)
  if (!document.querySelector("results-list")) return;

  const run = () => {
    try {
      const url = new URL(window.location.href);

      // If user already chose any tag filter, do nothing to respect their choice.
      // Shopify facet param for product tags is `filter.p.tag`.
      const hasAnyTag = Array.from(url.searchParams.keys()).some(
        (key) => key === "filter.p.tag"
      );
      if (hasAnyTag) return;

      let valueToApply = "";
      if (customerType === "company") valueToApply = companyValue;
      if (customerType === "association") valueToApply = associationValue;
      if (!valueToApply) return;

      // Apply ONLY if the filter exists on this page and is not disabled.
      const inputs = document.querySelectorAll('input[name="filter.p.tag"]');
      const exists = Array.from(inputs).some(
        (el) =>
          el instanceof HTMLInputElement &&
          el.value === valueToApply &&
          !el.disabled
      );
      if (!exists) return;

      // Append the facet and navigate. Keep any existing params (sort_by, q, etc.).
      url.searchParams.append("filter.p.tag", valueToApply);

      if (url.toString() !== window.location.href) {
        window.location.replace(url.toString());
      }
    } catch (_) {
      // Silently fail; filtering still works manually
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();
